/* eslint-disable */
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { LessonResultSection } from '../../organisms/lesson_result_section';
import { BrowserRouter } from 'react-router-dom';
export default class VjsResult extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "videoResultOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "resultPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.videoResultOptions = options;
        this.resultPlayer = player;
        this.mount = this.mount.bind(this);
        this.resultPlayer.ready(() => {
            this.mount();
        });
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement(BrowserRouter, null,
            React.createElement(LessonResultSection, Object.assign({ onClickExit: this.videoResultOptions.onClickExit }, this.processedOptions))));
    }
    get processedOptions() {
        this.videoResultOptions.resultOptions.vm.setVideoRefs(this.resultPlayer);
        return this.videoResultOptions.resultOptions;
    }
}
